import { render, staticRenderFns } from "./SearchQueryResults.vue?vue&type=template&id=d8c61e7a&"
import script from "./SearchQueryResults.vue?vue&type=script&lang=ts&"
export * from "./SearchQueryResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d8c61e7a', component.options)
    } else {
      api.reload('d8c61e7a', component.options)
    }
    module.hot.accept("./SearchQueryResults.vue?vue&type=template&id=d8c61e7a&", function () {
      api.rerender('d8c61e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/SearchQueryResults.vue"
export default component.exports